module.exports = __webpack_public_path__ + "img/knus_main0.82f3c531.jpg";